import React from "react";

// Aqua UI components and services
import { useToast } from '@longline/aqua-ui/services/Toast/useToast';

// Local application components
import { ProfileForm } from "./ProfileForm";
import { IProfile } from "../../api/models/IProfile";
import { useAuth } from "../../contexts/auth/useAuth";
import { Pane } from "../../ui/Pane";
import { useAccountContext } from "./IAccountContext";
import { View } from "@longline/aqua-ui/controls/View";

const EditProfile = () => {
  const auth = useAuth();
  const profileCtx = useAccountContext();

  // Local state hooks for tracking password fields. country is optional on
  // IUser but required on IProfile, so default the empty case to "".
  const [profile, setProfile] = React.useState<IProfile>({
    name: auth.user?.name ?? "",
    country: auth.user?.country ?? "",
    phoneNumber: auth.user?.phoneNumber ?? ""
  });
  const [isValid, setIsValid] = React.useState(true);

  // Local state hook for loading indicator:
  const [loading, setLoading] = React.useState(false);

  // Toast notification system
  const toastProvider = useToast();

  const handleSubmit = async () => {
    if(!isValid) return;
    setLoading(true);
    const result = await profileCtx.updateProfile(profile)
    if(result) {
      toastProvider.toast("Profile updated successfully.", { dismissable: true });
      profileCtx.setMode('view');
    } else {
      toastProvider.toast("Profile failed to update.", { dismissable: true });
    }
    setLoading(false);
  }

  const handleChange = (data: IProfile) => {
    setProfile({ ...profile, ...data });
  }

  const handleValidate = (valid: boolean) => {
    setIsValid(valid);
  }

  return (
    <>
      <Pane.Heading>
        <Pane.Title>Account</Pane.Title>
      </Pane.Heading>

      <Pane.Subheader expandable>
        Edit profile
      </Pane.Subheader>

      <Pane.Body>
        <View label="Email" hint="Email address">
          {auth.user?.email}
        </View>

        <ProfileForm
          data={profile}
          onChange={handleChange}
          onValidate={handleValidate}
        />
      </Pane.Body>

      <Pane.Footer>
        <Pane.CancelButton onClick={() => profileCtx.setMode('view')}/>
        <Pane.SubmitButton disabled={loading || !isValid} onClick={handleSubmit} working={loading}/>
      </Pane.Footer>
    </>
  )
}

export { EditProfile }
